import React, { useMemo } from 'react';
import Learn from './pages/Learn/Learn';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Layout from './components/Layout/Layout';
import Login from './pages/Login/Login';
import Setup from './pages/Setup/Setup';
import ModelsViewer from './pages/ModelsViewer/ModelsViewer';
import Translations from './pages/Translations/Translations';
import DashboardByConnection from './pages/DashboardByConnection/DashboardByConnection';
import AnalyticAccounts from './pages/AnalyticAccounts/AnalyticAccounts';
import ProductAnalysis from './pages/ProductAnalysis/ProductAnalysis';
import InvoiceAnalysis from './pages/InvoiceAnalysis/InvoiceAnalysis';
import UserManagement from './pages/UserManagement/UserManagement';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import { AuthProvider, useAuth } from './contexts/AuthContext';

const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#714B67',
    },
    secondary: {
      main: '#A582A0',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
  },
});

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#B896C9',
    },
    secondary: {
      main: '#D4B5E3',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
  },
});

// Protected route wrapper component
function ProtectedRoute({ isAuthenticated, children }) {
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function RouteContent() {
  const { darkMode } = useTheme();
  const { isAuthenticated, loading } = useAuth();
  const theme = useMemo(() => (darkMode ? darkTheme : lightTheme), [darkMode]);

  console.log('[RouteContent] Rendering with state:', { isAuthenticated, loading, darkMode });

  if (loading) {
    return (
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          backgroundColor: '#f5f5f5',
          fontFamily: 'Arial'
        }}>
          <div style={{ fontSize: '24px', marginBottom: '20px' }}>Cargando...</div>
          <div style={{ fontSize: '14px', color: '#666' }}>Por favor espera mientras se inicializa la aplicación</div>
        </div>
      </MuiThemeProvider>
    );
  }

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route path="/login" element={<Login />} />
        
        <Route
          path="/*"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout>
                <Routes>
                  <Route path="/" element={<Navigate to="/setup" replace />} />
                  <Route path="/setup" element={<Setup />} />
                  <Route path="/dashboard-by-connection" element={<DashboardByConnection />} />
                  <Route path="/models" element={<ModelsViewer />} />
                  <Route path="/translations" element={<Translations />} />
                  <Route path="/analytic-accounts" element={<AnalyticAccounts />} />
                  <Route path="/product-analysis" element={<ProductAnalysis />} />
                  <Route path="/invoice-analysis" element={<InvoiceAnalysis />} />
                  <Route path="/users" element={<UserManagement />} />
                  <Route path="/learn" element={<Learn />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </MuiThemeProvider>
  );
}

function AppContent() {
  return (
    <ThemeProvider>
      <RouteContent />
    </ThemeProvider>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
